const keyMappings = {
  machine: "agent.hostname",
};

const viewLogs = ({ timeframe, ...otherProps }) => {
  let query = "";

  const addQueryPart = (key, value) => {
    if (query.length > 0) {
      query += " and ";
    }
    query += key + ':"' + value + '"';
  };

  for (const key in otherProps) {
    if (key.length > 3 && key.startsWith("use")) continue;
    const kibanaKey =
      keyMappings[key] ||
      (key.indexOf("|") != -1 && key.substring(key.indexOf("|") + 1)) ||
      key;
    addQueryPart(kibanaKey, otherProps[key]);
  }
  const url = `https://cefdc660a357b051a56371e7ef69da1a.europe-west1.gcp.cloud.es.io:9243/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-${timeframe},to:now))&_a=(columns:!(message,category,supercategory),filters:!(),index:c1fe9e30-3c36-11e8-a553-7d7a273c1e41,interval:auto,query:(language:kuery,query:'${encodeURIComponent(
    query
  )}'),sort:!(!('@timestamp',desc)))`;

  window.open(url, "_blank");
};

export { viewLogs };
